import { useTranslation } from 'react-i18next';
import { Button, Modal, ModalActions, ModalContent, ModalTitleInfo } from '@c2fo/liquidity';
import { ExclamationTriangleIcon } from '@c2fo/liquidity/icons';

interface DeleteOfferConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Confirms turning participation off when it will delete an express accept or manually awarded offer.
 * Closes as soon as an action is chosen; progress and the result are shown by the participation snackbars.
 */
const DeleteOfferConfirmationModal = ({ open, onClose, onConfirm }: DeleteOfferConfirmationModalProps) => {
  const { t } = useTranslation();

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} size="sm">
      <ModalTitleInfo>{t('core.deleteOfferModal.title')}</ModalTitleInfo>
      <ModalContent className="py-0">
        <div className="mb-4 mt-2 flex justify-center">
          <ExclamationTriangleIcon aria-hidden="true" className="h-16 w-16 shrink-0 fill-red-600" />
        </div>
        <p className="pb-6 pt-2 text-left">{t('core.deleteOfferModal.description')}</p>
      </ModalContent>
      <ModalActions>
        <Button onClick={onClose} variant="secondary">
          {t('core.cancel')}
        </Button>
        <Button variant="destructive" onClick={handleConfirm}>
          {t('core.deleteOfferModal.confirm')}
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default DeleteOfferConfirmationModal;
